// extracted by mini-css-extract-plugin
module.exports = {"r1yd3t3b":"r1yd3t3b","title":"title"};